<template>
    <inertia-head>
        <title>{{seo.page_title}}</title>
        <meta name="title" :content="`${seo.page_title}`"/>
        <meta name="description" :content="`${seo.page_description}`"/>
        <meta name="keywords" :content="`${seo.key_words}`"/>
        <meta property="og:title" :content="`${seo.page_title}`"/>
        <meta property="og:description" :content="`${seo.page_description}`"/>
        <meta name="twitter:title" :content="`${seo.page_title}`">
        <link v-if="!seo.canonical_tag" rel="canonical" :href="canonicalLink"/>
        <link v-else rel="canonical" :href="`${seo.canonical_tag}`" />
        <meta v-if="seo.noindex_tag" name="robots" :content="`${seo.noindex_tag}`" />
    </inertia-head>

    <loading :show="loading"/>

    <div id="signup"
        class="bg-fixed bg-no-repeat bg-center relative"
        :style="`height: 100vh; background-size: cover; background-image: url(./storage/landing/yoga/header.webp)`"
        aria-label="A woman practicing yoga in a serene environment, depicting the calmness of becoming a yoga instructor."
    >
        <Header 
            :navigation_show="navigation" 
        />
        <div class="w-full sm:w-[400px] h-screen sm:h-auto items-center justify-center flex sm:absolute
            px-2 sm:px-0 sm:bottom-[20px] bottom-[0px] sm:right-[100px] right-[0px]">
            <div class="p-5 mx-auto border-white border bg-white justify-self-center shadow-lg rounded-2xl 
                backdrop-saturate-100 bg-opacity-30 backdrop-filter backdrop-blur-xl drop-shadow-md">
                <div class="text-center text-white">
                    <h1 class="text-[29px] font-bold">
                        Become a yoga instructor
                    </h1>
                    <h4 class="text-lg">
                        Find online or in-person clients
                    </h4>
                </div>
                <div class="">

                    <div class="pt-5">
                        <google-auth buttonJustify="justify-center" buttonWidth="w-100" role="master"/>
                    </div>

                    <div class="relative flex py-5 items-center">
                        <div class="flex-grow" style="border:1px solid #e7e2e2"></div>
                        <span class="flex-shrink mx-4 text-gray-400">Or</span>
                        <div class="flex-grow" style="border:1px solid #e7e2e2"></div>
                    </div>

                    <form @submit.prevent="submit">
                        <div>
                            <jet-label for="email" value="Email" />
                            <jet-input id="email" type="email" class="mt-1 block w-full" placeHolder="Email" v-model="form.email" required autofocus autocomplete="email" />
                        </div>
                        <div class="mt-4">
                            <jet-label for="password" value="Password" />
                            <jet-input id="password" type="password" class="mt-1 block w-full" placeHolder="Password" v-model="form.password" required autocomplete="new-password" />
                        </div>

                        <div class="mt-4">
                            <jet-label for="password_confirmation" value="Confirm password" />
                            <jet-input 
                                id="password_confirmation" 
                                type="password" 
                                class="mt-1 block w-full"
                                placeHolder="Confirm password"  
                                v-model="form.password_confirmation" 
                                required 
                                autocomplete="new-password" 
                            />
                        </div>
                        <div class="mt-4">
                            <jet-label for="terms">
                                <div class="flex items-center">
                                    <jet-checkbox name="terms" id="terms" v-model:checked="form.terms" />

                                    <div class="ml-2 text-white">
                                        By using this website or signing up, you agree to Happy Trainers <a target="_blank" href="/term-of-service"
                                        class="underline text-sm text-gray-500 hover:text-gray-700">Terms of Service</a> and 
                                        <a target="_blank" href="/privacy-policy" class="underline text-sm text-gray-500 hover:text-gray-700">
                                        Privacy Policy</a>
                                    </div>
                                </div>
                            </jet-label>
                        </div>
                        <div class="text-center mt-3">
                            <span class="text-red-500 text-sm" v-html="msg"></span>
                        </div>
                    </form>
                </div>
                <div class="items-center my-4">
                    <button class="gold-btn w-full text-xl rounded-lg p-3" @click="submit"> Sign up </button>
                    <div class="mt-3">
                        <span class="mx-1 text-white">Already have an account?</span>
                        <span @click="loginPage" class="cursor-pointer text-sm text-white underline">Log in</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <main class="container container-xl mx-auto mb-6">

            <section class="rounded-2xl shadow-xl bg-white p-3 sm:p-9 border mx-2 mt-10 sm:mx-auto">
                <!-- <h2 class="sm:text-5xl text-xl text-center py-3">TITLE</h2> -->
                <!-- <p class="sm:text-3xl text-lg text-center py-3 text-gray-400"> DESCRIPTION </p> -->
                <div class="sm:p-4 grid grid-cols-6 gap-6">
                    <div class="col-span-6 sm:col-span-2">
                        <div class="px-4 text-center">

                            <div class="w-full flex items-center justify-center" style="height: 200px">
                                <img
                                    alt="A red clock and golden coins, symbolizing the connection between time and money after becoming a yoga instructor."
                                    src="/storage/landing/yoga/time-is-money.webp" 
                                    width="200" 
                                >
                            </div>
                                <h4 class="sm:text-[26px] text-[24px] mt-3">
                                    {{ landing.content?.rowOne?.oneTitle }}
                                </h4>
                            <p class="text-lg whitespace-normal mt-3 text-left" v-html="landing.content?.rowOne?.oneContent"></p>
                        </div>
                    </div>
                    <div class="col-span-6 sm:col-span-2">
                        <div class="px-4 text-center">

                            <div class="w-full flex items-center justify-center mb-3" style="height: 200px">
                                <img
                                    alt="A woman exercises on a computer screen, with live stream and Wi-Fi icons beside her, highlighting online yoga sessions."
                                    src="/storage/landing/yoga/online-icon.webp" 
                                    width="180" 
                                >
                            </div>
                                <h4 class="sm:text-[26px] text-[24px] mt-3">
                                    {{ landing.content?.rowOne?.twoTitle }}
                                </h4>
                            <p class="text-lg whitespace-normal mt-3 text-left" v-html="landing.content?.rowOne?.twoContent"></p>
                        </div>
                    </div>
                    <div class="col-span-6 sm:col-span-2">
                        <div class="px-4 text-center">

                            <div class="w-full flex items-center justify-center mb-3" style="height: 200px">
                                <img
                                    alt="A calendar with a clock, demonstrating time management after becoming a yoga instructor."
                                    src="/storage/landing/yoga/schedule-icon.webp" 
                                    width="160" 
                                >
                            </div>
                            <h4 class="sm:text-[25px] text-[24px] mt-3">
                                    {{ landing.content?.rowOne?.threeTitle }}
                            </h4>
                            <p class="text-lg whitespace-normal mt-3 text-left" v-html="landing.content?.rowOne?.threeContent"></p>
                        </div>
                    </div>
                </div>
            </section>

            <section class="rounded-2xl shadow-xl bg-white px-5 py-3 sm:py-9 border mx-2 mt-10 sm:mx-auto">
                <div class="sm:p-4 grid grid-cols-6 gap-6">
                    <div class="col-span-6 sm:col-span-3">
                        <div class="px-auto">
                            <h1 class="text-3xl font-bold ">
                                {{ landing.content?.rowTwo?.title }}
                            </h1>
                            <a class="text-lg">
                                <p class="my-2" v-html="landing.content?.rowTwo?.contentOne">
                                </p>
                            </a>
                        </div>
                    </div>
                    <div class="col-span-6 sm:col-span-3">
                        <div class="flex justify-center">
                            <img
                                alt="A woman participating in an online yoga session, looking at a yoga instructor on a laptop screen."
                                src="/storage/landing/yoga/section-2.webp">
                        </div>
                    </div>
                </div>
                <div class="sm:p-4 text-lg" v-html="landing.content?.rowTwo?.contentTwo">
                </div>
            </section>

            <section class="rounded-2xl shadow-xl bg-white px-5 py-3 sm:py-9 border mx-2 mt-10 sm:mx-auto">
                <h2 class="sm:text-4xl text-2xl text-center pb-10 text-gray-600 font-bold">
                    Steps to become a trainer
                </h2>
                <div class="w-full flex justify-center">
                    <div class="step sm:mb-[35px] mb-0 before:hidden sm:before:block">
                        <ul class="step-list sm:flex block w-[unset] sm:w-full mx-auto sm:mx-0 ps-0">
                            <div class="step-section mb-[60px] sm:mb-0">
                                <li class="step-item">
                                    <img alt="" src="/storage/landing/step1.svg">
                                </li>
                                <a class="step-title font-bold text-gray-600 text-[14px]"> 1. Personal info  </a>
                            </div>
                            <div class="step-section mb-[60px] sm:mb-0">
                                <li class="step-item">
                                    <img alt="" src="/storage/landing/step3.svg">
                                </li>
                                <a class="step-title font-bold text-gray-600 text-[15px]"> 2. Certification </a>
                            </div>
                            <div class="step-section mb-[60px] sm:mb-0">
                                <li class="step-item">
                                    <img alt="" src="/storage/landing/step4.svg">
                                </li>
                                <a class="step-title font-bold text-gray-600 text-[15px]"> 3. Experience </a>
                            </div>
                            <div class="step-section mb-[60px] sm:mb-0">
                                <li class="step-item">
                                    <img alt="" src="/storage/landing/step2.svg">
                                </li>
                                <a class="step-title font-bold text-gray-600 text-[15px]"> 4. Photo </a>
                            </div>
                            <div class="step-section mb-[60px] sm:mb-0">
                                <li class="step-item">
                                    <img alt="" src="/storage/landing/step5.svg">
                                </li>
                                <a class="step-title font-bold text-gray-600 text-[15px]"> 5. Description </a>
                            </div>
                            <div class="step-section mb-[60px] sm:mb-0">
                                <li class="step-item">
                                    <img alt="" width="62px" src="/storage/landing/step7.svg">
                                </li>
                                <a class="step-title font-bold text-gray-600 text-[15px]"> 6. Availability </a>
                            </div>
                            <div class="step-section mb-[60px] sm:mb-0">
                                <li class="step-item">
                                    <img alt="" src="/storage/landing/step6.svg">
                                </li>
                                <a class="step-title font-bold text-gray-600 text-[15px]"> 7. Video </a>
                            </div>
                        </ul>
                    </div>

                </div>
            </section>

            <section class="rounded-2xl shadow-xl bg-white px-5 py-3 sm:py-9 border mx-2 mt-10 sm:mx-auto">
                <!-- <h2 class="sm:text-5xl text-xl text-center py-3">TITLE</h2> -->
                <!-- <p class="sm:text-3xl text-lg text-center py-3 text-gray-400"> DESCRIPTION </p> -->
                <div class="grid grid-cols-7 gap-6">
                    <div class="col-span-7 sm:col-span-4">
                        <div class="sm:p-4 py-2">
                            <h1 class="text-gray-600 text-4xl font-bold">
                                {{ landing.content?.rowThree?.titleOne}}
                                <p class="text-green-500">
                                    {{ landing.content?.rowThree?.titleTwo}}
                                </p>
                            </h1>
                            <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                                <div class="my-5">
                                    <div class="flex items-center my-3">
                                        <span class="material-icons mx-2 text-[30px] text-green-500">search</span>
                                        <span class="text-[18px] mt-[6px]"> Find new clients </span>
                                    </div>
                                    <div class="flex items-center my-3">
                                        <span class="material-icons mx-2 text-[30px] text-green-500">event</span>
                                        <span class="text-[18px] mt-[6px]">  Set your own schedule </span>
                                    </div>
                                    <div class="flex items-center my-3">
                                        <span class="material-icons mx-2 text-[30px] text-green-500">attach_money</span>
                                        <span class="text-[18px] mt-[6px]"> Earn based on your expertise </span>
                                    </div>
                                </div>
                                <div class="flex flex-col justify-center items-center">
                                    <a href="#signup" class="rounded-full py-2 px-[30px] text-white text-[15px] sm:text-[18px] mx-2 gold-btn">
                                        Become a yoga instructor
                                    </a>
                                    <div class="my-3 sm:my-5 items-center justify-center flex flex-row sm:flex-col text-green-500">
                                        <div class="flex items-center justify-center">
                                            <span class="material-icons">info</span>
                                            <a href="mailto:support@happytrainers.com" class="font-bold text-[13px] sm:text-[18px]">
                                                Need assistance?
                                            </a>
                                        </div>
                                        <div class="flex justify-center items-center px-1 sm:px-0">
                                            <a href="mailto:support@happytrainers.com" class="font-bold text-[13px] sm:text-[18px]">
                                                Contact us!
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <a class="text-lg my-2" v-html="landing.content?.rowThree?.contentOne">
                            </a>
                        </div>
                    </div>
                    <div class="col-span-7 sm:col-span-3">
                        <div class="rounded-2xl">
                            <img class="sm:rounded-tr-2xl" src="/storage/landing/yoga/section-3.webp"
                                alt="A woman practicing yoga with a female yoga instructor in a studio."
                            >
                        </div>
                    </div>
                </div>
                <div class="sm:p-4 py-5 text-lg" v-html="landing.content?.rowThree?.contentTwo">
                </div>
            </section>

            <section class="text-center rounded-2xl shadow-xl bg-white px-5 py-3 sm:py-9 border mx-2 mt-10 sm:mx-auto relative">
                <div class="px-2 py-2 bg-green-500 text-white border w-64 rounded-full text-xl mx-auto mt-3 absolute z-10 -top-8 inset-x-0">
                    FAQ
                </div>

                <div class="">
                    <div v-for="(item,key) in faqs" :key="key" class="sm:mt-5 mt-3">
                        <div @click="faqIndex===item.id ? faqIndex=null : faqIndex=item.id"
                             :class="{'border border-yellow-400': faqIndex===item.id  }"
                             class="border border-gray-300 cursor-pointer rounded-full sm:p-3 p-1 justify-between flex">

                            <div class="flex items-center">
                                <span class="material-icons text-green-600">help</span>
                                <h2 class="ml-3 break-words text-justify text-lg">{{ item.question }}</h2>
                            </div>

                            <div class="sm:mr-4">
                                <span v-if="faqIndex===item.id" class="material-icons">keyboard_arrow_up</span>
                                <span v-else class="material-icons">expand_more</span>
                            </div>
                        </div>

                        <div v-show="faqIndex===item.id" class="sm:p-5 p-2 mt-2 border border-gray-300 sm:mx-4 rounded-lg transition">
                            <p class="ml-3 break-words text-justify text-lg" v-html="item.answer"></p>
                        </div>
                        <hr />
                    </div>
                </div>
            </section>
            
        </main>

        <Footer/>
</template>

<script>
import Select from "@/Jetstream/Select";
import Button from "@/Jetstream/Button";
import myMixin from "@/myMixin";
import Header from "@/Pages/Components/Header";
import Footer from "@/Pages/Components/Footer";
import {Link, InertiaHead} from '@inertiajs/inertia-vue3'
import {Inertia} from '@inertiajs/inertia';
import Loading from "@/Jetstream/Loading";
import JetInput from '@/Jetstream/Input'
import JetCheckbox from "@/Jetstream/Checkbox";
import GoogleAuth from "@/Components/Auth/GoogleAuth";

export default {
    name: "Index",
    mixins: [myMixin],
    props: {
        categories: Array,
        options: Array,
        faqs: Array,
        seo: Object,
        canonicalLink: String,
        landing: Array,
    },
    components: {Footer, Button, Select, Header, Link, InertiaHead, Loading, JetInput, JetCheckbox, GoogleAuth},
    mounted() {
        Inertia.on('start', event => {
            this.loading = true
        });

        Inertia.on('finish', event => {
            this.loading = false
        })
    },
    data() {
        return {
            navigation: null,
            showAllService: false,
            faqIndex: null,
            categorySelected: null,
            price: null,
            loading: false,
            msg: "",
            form: this.$inertia.form({
                email: '',
                password: '',
                password_confirmation: '',
                terms: false,
                role: 'master',
            })
        }
    },
    methods: {
        loginPage(){
            return this.goTo('/login');
        },
        submit() {
            this.msg = '';
            if ( this.form.email && this.form.password && this.form.password_confirmation && this.form.terms ) {
                axios.post(this.route('master.register'), this.form)
                .then(response => {
                    this.goTo("/register-wizard")
                }).catch((error) => {
                    this.msg = error.response.data.message;
                })
            } else if(this.form.email && this.form.password && this.form.password_confirmation && !this.form.terms) {
                this.msg = 'Please check the Terms of Service and Privacy Policy';
            } else { 
                this.msg = 'Please enter your information carefully.';
            }
        }
    },
}
</script>

<style scoped>
.step {
  position: relative;
  display: flex;
  width: 90%;
}

.step:before {
    content: "";
    position: absolute;
    background-color: #dddddd;
    height: 2px;
    width: 100%;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
}

.step-list {
    align-items: center;
    justify-content: space-between;
}

.step-section {
    z-index: 2;
    position: relative;
    display: flex;
    justify-content: center;
}

.step-item {
    z-index: 2;
    transition: 0.4s ease;
    min-width: 100px;
    max-width: 100px;
    height: 100px;
    border-radius: 50%;
    border: .5px solid #8a8a8a;
    color: #06ae4e;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 18px;
    background-color: #f4f4f4;
    white-space: nowrap;
}

.step-title {
    position: absolute;
    bottom: -40px;
    width: 200px;
    text-align: center;
}
</style>